import { get } from 'lodash/fp';
import { createSelector } from 'reselect';
import {
    createAsyncActionTypes,
    createAsyncMetaSelectors,
    createScopedReducer,
    createScopedSelector,
} from '@mews/framework';
import { META_STATE_SUCCEEDED } from '@mews-commander/legacy-entities/src/constants';
import { createEntityAsyncMetaHandlers } from '@mews-commander/legacy-entities/src/ducks/utils';
import { moduleSelector as parentSelector, prefix } from '../module';

export const NAME = 'billName';

const BILL_NAME_FETCH = prefix('BILL_NAME_FETCH');
const [BILL_NAME_FETCH_STARTED, BILL_NAME_FETCH_SUCCEEDED, BILL_NAME_FETCH_FAILED] =
    createAsyncActionTypes(BILL_NAME_FETCH);

const INITIAL_STATE = {
    billNameDialogOpened: false,
    billId: null,
    ...META_STATE_SUCCEEDED,
};

export const billNameReducer = createScopedReducer(INITIAL_STATE, {
    ...createEntityAsyncMetaHandlers({
        STARTED: BILL_NAME_FETCH_STARTED,
        SUCCEEDED: BILL_NAME_FETCH_SUCCEEDED,
        FAILED: BILL_NAME_FETCH_FAILED,
    }),
});

const moduleSelector = createSelector(parentSelector, get(NAME));

const getScope = createScopedSelector({ parentSelector: moduleSelector, initialState: INITIAL_STATE });

const getMeta = createSelector(getScope, get('meta'));

export const getBillNameDialogBillId = createSelector(getScope, get('billId'));

export const [isFetching, hasFailed] = createAsyncMetaSelectors(getMeta);

export const isBillNameDialogOpened = createSelector(getScope, get('billNameDialogOpened'));
